import * as primitives from './primitives'

export const $background = {
  light: primitives.$white,
  dark: primitives.$black
}

export const $layer1 = {
  light: primitives.$neutralGray10,
  dark: primitives.$neutralGray100
}

export const $layer2 = {
  light: primitives.$neutralGray20,
  dark: primitives.$neutralGray90
}

export const $layer3 = {
  light: primitives.$neutralGray30,
  dark: primitives.$neutralGray80
}

export const $overlay = {
  // rrggbbaa notation
  light: `${primitives.$monoGray}48`,
  dark: `${primitives.$monoGray}48`
}

export const $borderStrong = {
  light: `${primitives.$black}92`,
  dark: `${primitives.$white}92`
}

export const $borderMedium = {
  light: `${primitives.$black}56`,
  dark: `${primitives.$white}48`
}

export const $borderSubtle = {
  light: `${primitives.$black}60`,
  dark: `${primitives.$white}16`
}

export const $textPrimary = {
  light: primitives.$neutralGray100,
  dark: primitives.$neutralGray10,
  holiday: '#FEF3C7'
}

export const $textSecondary = {
  light: primitives.$neutralGray70,
  dark: primitives.$neutralGray30
}

export const $textTertiary = {
  light: primitives.$neutralGray60,
  dark: primitives.$neutralGray50
}

export const $textInteractive = {
  light: primitives.$red60,
  dark: primitives.$red40
}

export const $interactivePrimary = {
  light: primitives.$red60,
  dark: primitives.$red70
}

export const $interactiveSecondary = {
  light: primitives.$neutralGray100,
  dark: primitives.$neutralGray10
}

export const $textOnInteractivePrimary = {
  light: primitives.$neutralGray10,
  dark: primitives.$neutralGray10
}

export const $textOnInteractiveSecondary = {
  light: primitives.$neutralGray10,
  dark: primitives.$neutralGray100
}

export const $brandABlack = {
  light: primitives.$black,
  dark: primitives.$black
}

export const $brandA100 = {
  light: primitives.$neutralGray100,
  dark: primitives.$neutralGray100
}

export const $brandA50 = {
  light: primitives.$neutralGray50,
  dark: primitives.$neutralGray50
}

export const $brandA10 = {
  light: primitives.$neutralGray10,
  dark: primitives.$neutralGray10
}

export const $brandAWhite = {
  light: primitives.$white,
  dark: primitives.$white
}

export const $brandB70 = {
  light: primitives.$red70,
  dark: primitives.$red70
}

export const $brandB60 = {
  light: primitives.$red60,
  dark: primitives.$red60
}

export const $brandB40 = {
  light: primitives.$red40,
  dark: primitives.$red40
}

export const $preOrder = primitives.$purple70
export const $holidaySale = '#022C22'
export const $error = '#FFAA00'
